import axios from 'axios';
import querystring from 'qs';
export default {
    name: 'Checks',
    props: ['month', 'year','date'],
    data() {
        return {
            missingChecks: [],
            clientChecks: [],
            attendantChecks: [],
        }
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {
            //this.date = new Date();
            const params = {
                date: this.date,
            };

            //this.initialized = false;
            let missingUrl = APIURL + '/attendantactivity/activitymissingqualification/' + this.year + '/' + this.month+"?"  + querystring.stringify(params);
            axios.get(missingUrl)
                .then(resp => {
                    this.missingChecks = resp.data;
                });

            let clientdoubleUrl = APIURL + '/attendantactivity/clientdouble/' + this.year + '/' + this.month + "?" + querystring.stringify(params);
            axios.get(clientdoubleUrl)
                .then(resp => {
                    this.clientChecks = resp.data;
                });

            let attendantdoubleUrl = APIURL + '/attendantactivity/attendantdouble/' + this.year + '/' + this.month + "?" + querystring.stringify(params);
            axios.get(attendantdoubleUrl)
                .then(resp => {
                    this.attendantChecks = resp.data;
                });

        },        
    }
};